import { Link, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";

export function SectionHeading({
  title,
  en,
  desc,
  more,
}: {
  title: string;
  en?: string;
  desc?: string;
  more?: { to: string; label: string };
}) {
  return (
    <div className="mb-6 flex items-end justify-between gap-4 border-b border-background-200/80 pb-4">
      <div>
        <div className="flex items-center gap-2.5">
          <span className="h-5 w-1.5 rounded-full bg-primary-500"></span>
          <h2 className="font-display text-xl font-bold text-foreground-950 md:text-2xl">{title}</h2>
          {en && <span className="text-xs tracking-widest text-foreground-400">{en}</span>}
        </div>
        {desc && <p className="mt-2 text-sm text-foreground-600">{desc}</p>}
      </div>
      {more && (
        <Link
          to={more.to}
          className="group flex shrink-0 items-center gap-1 whitespace-nowrap text-sm text-foreground-500 transition-colors hover:text-primary-600"
        >
          {more.label}
          <i className="ri-arrow-right-line transition-transform group-hover:translate-x-0.5"></i>
        </Link>
      )}
    </div>
  );
}

export function Breadcrumb({ items }: { items: { label: string; to?: string }[] }) {
  return (
    <nav aria-label="面包屑" className="flex flex-wrap items-center gap-1.5 text-sm text-foreground-500">
      <Link to="/" className="flex items-center gap-1 transition-colors hover:text-primary-600">
        <i className="ri-home-5-line"></i>
        首页
      </Link>
      {items.map((it, i) => (
        <span key={i} className="flex items-center gap-1.5">
          <i className="ri-arrow-right-s-line text-foreground-300"></i>
          {it.to ? (
            <Link to={it.to} className="transition-colors hover:text-primary-600">
              {it.label}
            </Link>
          ) : (
            <span className="text-foreground-700">{it.label}</span>
          )}
        </span>
      ))}
    </nav>
  );
}

export function BackTop() {
  const [show, setShow] = useState(false);
  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 600);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  if (!show) return null;
  return (
    <button
      type="button"
      aria-label="返回顶部"
      onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
      className="fixed bottom-6 right-6 z-40 flex h-11 w-11 items-center justify-center rounded-full bg-primary-500 text-background-50 shadow-lg transition-colors hover:bg-primary-600"
    >
      <i className="ri-arrow-up-line"></i>
    </button>
  );
}

export function useScrollTop() {
  const { pathname, search } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "auto" });
  }, [pathname, search]);
}